// Module
var code = "<div class=\"property-container\"></div> <select data-bind=\"options: $data._types, optionsText: 'Name', value: $data._selectedType, optionsCaption: 'All'\" class=\"form-control\"></select> ";
// Exports
export default code;